const stage = 'https://j8xvd1iyxc.execute-api.ca-central-1.amazonaws.com/IFM2/';





export const environment = {
  production: false,
  webSocket: "wss://ifm-dev.mwstudio.io:4002",
  tileServer: "https://tile.openstreetmap.org", // As of 27/06/2025, the DEV server does not have its own tile-server service, so we use OSM servers instead
  ors: "https://ifm-dev.mwstudio.io:4000/ors",
  cognito :{
    userPoolId : "ca-central-1_Bp8ozfBkH",
    userPoolWebClientId: "7nsbfeejrak4egs9n8e024l1l0",
    region: 'ca-central-1',
    identityPoolId: 'ca-central-1:ff34f699-f6ec-43e4-a6f1-887f09da54df',
    sessionToken: sessionStorage.getItem("sessionToken") || "",
    accessKeyId: sessionStorage.getItem("accessKeyId") || "",
    secretAccessKey: sessionStorage.getItem("secretAccessKey") || "",
    userPoolClientId: 'ca-central-1_Bp8ozfBkH',
    username: 'true',
    email: 'false', // Optional
    phone: 'false', // Optional
  },
  sns: {
    url: "",
  },
  iot: {
    region: 'ca-central-1',
    accessKeyId: sessionStorage.getItem("accessKeyId") || "",
    secretAccessKey: sessionStorage.getItem("secretAccessKey") || "",
    sessionToken: sessionStorage.getItem("sessionToken") || "",
    endpoint: 'a1oadwr7wa53ee-ats.iot.ca-central-1.amazonaws.com',
    policy: 'arn:aws:iot:ca-central-1:478507580210:policy/MWS-B01',
 },
  api:{
    stage: stage,
    route: {
        createBin: 'bins?action=createBin',
        createBinModel: 'bins?action=createBinModel',
        createClient: 'clients?action=createClient',
        createDeviceNote: 'devices?action=createDeviceNote',
        createDistributor: 'distributors?action=createDistributor',
        createEntitiesLocations: 'entities?action=createEntitiesLocation',
        createOperator: 'operators?action=createOperator',
        createTaxType: 'taxType?action=createTaxeType',
        createUser: 'users?action=createUser',
        createUserRole: 'users?action=createUserRoles',
        createWorkOrder: 'workOrders?action=createWorkOrder',
        createClientZone: 'clients?action=createClientZone',
        deleteUserRoles: 'users?action=deleteUserRoles',
        deleteClientZone: 'clients?action=deleteClientZone',
        deleteDeviceReferences: 'devices?action=deleteDeviceReferences',
        deleteDeviceLogs: 'devices?action=deleteDeviceLogs',
        deleteDeviceReportDatas: 'devices?action=deleteDeviceReportDatas',
        deleteUserAdvanceAlertPreferences: 'users?action=deleteUserAdvanceAlertPreferences',
        enableDisableUser: 'users?action=enableDisableUser',
        getAllEntityWorkOrders: 'workOrders?action=getAllEntityWorkOrder',
        getAvailableDistributorDevices: 'distributors?action=getAvailableDistributorDevice',
        getBinById: 'bins?action=getBinById',
        getBinModel: 'bins?action=getBinModelById',
        getBins: 'bins?action=getBins',
        getBinsByClientId: 'bins?action=getBinsByClientId',
        getBinModels: 'bins?action=getBinModels',
        getBinModelAssociationsByDistributorId: 'bins?action=getBinModelAssociationByDistributorId',
        getClientBins: 'bins?action=getBinsByClientId',
        getClientById: 'clients?action=getClientById',
        getClientLegalName: 'clients?action=getClientLegalName',
        getClientThings: 'clients?action=getClientThings',
        getClientThingByThingName: 'getClientThingByThingName', // not used
        getClients: 'clients?action=getClients',
        getDevicesByBinId: 'devices?action=getDeviceByBinId',
        getDeviceByDistributorId: 'devices?action=getDeviceByDistributorId',
        getDeviceConfigs: 'devices?action=getDeviceConfigs',
        getDeviceNotes: 'devices?action=getDeviceNotes',
        getDeviceRelationshipByThingname: 'devices?action=getDeviceRelationshipsByThingName&thing_name=', // Dont forget to pass thingName when using this route
        returnDeviceRelationShipsByThingNameWithRelated: 'devices?action=returnDeviceRelationShipsByThingNameWithRelated&thing_name=', // Dont forget to pass thingName when using this route
        getDistributorLegalName: 'distributors?action=getDistributorLegalName',
        getDistributors: 'distributors?action=getDistributors',
        getEntitiesLocations: 'entities?action=getEntitiesLocations',
        getEntityLocationById: 'entities?action=getEntityLocationById',
        getHistoryByDate: 'reports?action=getHistoryByDate',
        getHistoryBatch: 'reports?action=getHistoryBatch',
        getOperatorLegalName: 'operators?action=getOperatorLegalName',
        getOperators: 'operators?action=getOperators',
        getUsersByDistributorId: 'users?action=getUserByDistributorId',
        getZones: 'clients?action=getZones',
        getTaxType: 'taxType?action=getTaxType',
        getWorkOrders: 'workOrders?action=getAllWorkOrders',
        getUserRoles: 'users?action=getUserRoles',
        getUserAdvanceAlertPreferences: 'users?action=getUserAdvanceAlertPreferences',
        initializeDeviceforProduction: 'devices?action=initializeDeviceforProduction',
        saveDeviceNote: 'devices?action=saveDeviceNote',
        setDeviceAssociation: 'devices?action=setDeviceAssociations',
        getDeviceHealth:'devices?action=getDeviceHealth',
        setUserAdvanceAlertPreferences: 'users?action=setUserAdvanceAlertPreferences',
        setUserIsAdvanceAlertPreference: 'users?action=setUserIsAdvanceAlertPreference',
        shadowUpdateLogs: 'devices?action=shadowUpdateLog',
        updateBin : 'bins?action=updateBin',
        updateBinModel: 'bins?action=updateBinModel',
        updateClient: 'clients?action=updateClient',
        updateDeviceAssociation: 'devices?action=updateDeviceAssociations',
        updateDeviceNote: 'devices?action=updateDeviceNote',
        updateDistributor: 'distributors?action=updateDistributor',
        updateEntitiesLocations: 'entities?action=updateEntityLocation',
        updateOperator: 'operators?action=updateOperator',
        updateTaxType: 'taxType?action=updateTaxType',
        updateUser: 'users?action=updateUser',
        updateUserRole: 'users?action=updateUserRoles',
        updateClientZone: 'clients?action=updateClientZone',
        updateWorkOrder: 'workOrders?action=updateWorkOrder',
        getDeviceHistory: 'reports?action=history&thing_name=', // Dont forget to pass thingName when using this route
        getBinByDevice: 'bins?action=getBinByDevice&thing_name=', // Dont forget to pass thingName when using this route
        getDeviceRelationships: 'devices?action=getDeviceRelationships',
        getUsersByClientId: 'users?action=getUserByClientId',
        getReportFilterOptions: 'reports?action=filters',
        getReportData: 'reports?action=collections',
        getThingShadows: 'devices?action=shadows',
        getUserAlertPreferenceDB: 'users?action=getUserAlertPreferenceDB',
        updateUserAlertPreferenceDB: 'users?action=updateUserAlertPreferenceDB',
        getBinsForDevices: 'bins?action=getBinsForDevices',
        deleteClientAndRelatedData: 'clients?action=deleteClientAndRelatedData',
        deleteDistributorAndRelatedData: 'distributors?action=deleteDistributorAndRelatedData',
        getUser: 'users?action=getUser',
        saveProductionStatus: 'devices?action=saveDeviceProductionStatus',
        deleteOperator: 'operators?action=deleteOperator',
        getAllUsers: 'users?action=getAllUsers',
        getChatUsers: 'chat?action=getChatUsers',
        getChatLog: 'chat?action=getChatLog',
        getAllChatLogByUserSub: 'chat?action=getAllChatLogByUserSub',
        getTodayRoutes: 'routes?action=getTodayRoutes',
        getOperatorClientsById: 'operators?action=getOperatorClientsById',
        setOperatorClients: 'operators?action=setOperatorClients',
        getClientsByMultipleIds: 'clients?action=getClientsByMultipleIds',
        createTruck: 'trucks?action=createTruck',
        getAllTrucks: 'trucks?action=getAllTrucks',
        getTrucks4Graph: 'trucks?action=getTrucks4Graph',
        getTrucksByOperatorId: 'trucks?action=getTrucksByOperatorId',
        getTruckByTruckId: 'trucks?action=getTruckByTruckId',
        updateTruck: 'trucks?action=updateTruck',
        //sendJsonToAPI: 'sendJsonToAPI?action=callByCron',
        getAllDriversByOperatorId: 'trucks?action=getAllDriversByOperatorId',
        updateDriverTruckAssociation: 'trucks?action=updateDriverTruckAssociation',
        isTruckVINUnique: 'trucks?action=isTruckVINUnique',
        getOperatorZones: 'operators?action=getOperatorZones',
        getOperatorZoneDevices: 'operators?action=getOperatorZoneDevices',
        createOperatorZone: 'operators?action=createOperatorZone',
        updateOperatorZone: 'operators?action=updateOperatorZone',
        deleteOperatorZone: 'operators?action=deleteOperatorZone',
        setOperatorZoneDevices: 'operators?action=setOperatorZoneDevices',
        removeOperatorZoneDevices: 'operators?action=removeOperatorZoneDevices',
        getZonesAndAssociatedEntities: 'clients?action=getZonesAndAssociatedEntities',
        //testWebsocket: 'test?action=testWebsocket', // not used
        getNotificationByUsersub: 'notifications?action=getNotificationByUsersub',
        getTruckIdByDriverId: 'trucks?action=getTruckIdByDriverId',
        getRoutesIdByTruckId: 'routes?action=getRoutesIdByTruckId',
        getRouteStopByRouteId: 'routes?action=getRouteStopByRouteId',
        getStopsDetails: 'routes?action=getStopsDetails',
        getDispatchRoutes: 'routes?action=getDispatchRoutes',
        getDispatchRouteStops: 'routes?action=getDispatchRouteStops',
        getUsersDriversByOperatorId: 'users?action=getUsersDriversByOperatorId',
        updateRouteStopStatus: 'routes?action=updateRouteStopStatus',
        logRouteStop: 'routes?action=logRouteStop',
        startRoute: 'routes?action=startRoute',
        endRoute: 'routes?action=endRoute',
        getAllDevice: 'devices?action=getAllDevice',
        sendMessage: 'chat?action=sendMessage',
        getAssociatedClients: 'clients?action=getAssociatedClients',
        createConversation: 'chat?action=createConversation',
        getChatLogbyID: 'getChatLogbyID?action=getChatLogbyID',// no route on api gateway
        getOperatorChatUsers:'chat?action=getOperatorChatUsers',
        getAdminChatUsers: 'chat?action=getAdminChatUsers',
        getCurrentChatUser: 'chat?action=getCurrentChatUser',
        getFirmwareVersions: 'devices?action=getFirmwareVersions',
        uploadFile: 'uploadFile?action=uploadFile',// no route on api gateway
        getClientChatUsers: 'chat?action=getClientChatUsers',
        createDeviceSubGroup: 'devices?action=createDeviceSubGroup',
        getClientSubGroup: 'devices?action=getClientSubGroup',
        addDevicesToSubGroup: 'devices?action=addDevicesToSubGroup',
        removeDevicesFromSubGroup: 'devices?action=removeDevicesFromSubGroup',
        deleteSubGroup: 'devices?action=deleteSubGroup',
        deleteReasignSubGroup: 'deleteReasignSubGroup?action=deleteReasignSubGroup', // no route on api gateway
        markMessagesReadDB: 'markMessagesReadDB?action=markMessagesReadDB', // no route on api gateway
        createMaintenanceLog: 'maintenance?action=createMaintenanceLog',
        getLatestLogByThingName: 'maintenance?action=getLatestLogByThingName',
        getAllLogsByThingName: 'maintenance?action=getAllLogsByThingName',
        getLatestLogForAllThings: 'maintenance?action=getLatestLogForAllThings',
        getAllDevices : 'maintenance?action=getAllDevices',
        getAllEntitiesForApiManagement: 'entities?action=getAllEntitiesForApiManagement',
        saveApiKey: 'entities?action=saveApiKey',
        getApiKey: 'entities?action=getApiKey',
        resendKeyToEmail: "entities?action=resendKeyToEmail",
        getClientInvoice: 'clients?action=invoice',
        getAllThingShadows: 'devices?action=all_shadows',
        createClientInvoiceTemplate : 'clients?action=createClientInvoiceTemplate',
        getClientInvoiceTemplate : 'clients?action=getClientInvoiceTemplate',
        deleteClientInvoiceTemplate : 'clients?action=deleteClientInvoiceTemplate',
    },
  },
  google: {
    APIKey: 'AIzaSyCyzMRxB8Re27NYcuI8KDFCEucI0GwHLHA&libraries=drawing',
  },
  users:{
    superAdmin: "muirwood",
    standardUser: "client",
    supplier: "distributor",
    maintenance: "operator",
    role: {
      administrator: "_admin",
      client: "_client",
      distributor: "_distributor",
      operations: "_operations",
      driver: "_driver",
      dispatch: "_dispatch",
    },
  },
  saml:{
    microsoft: {
      clientId: '58704f7c-1889-4e8e-9474-155df9919ce8',
      authority: 'https://login.microsoftonline.com/c0b50357-f018-4f60-bf08-47342010bf9b/',
      redirectUri: "https://ifm-dev.mwstudio.io/login",
      provider: "login.microsoftonline.com/c0b50357-f018-4f60-bf08-47342010bf9b/v2.0",
      domain: "sts.windows.net/c0b50357-f018-4f60-bf08-47342010bf9b",
      navigateToLoginRequestUrl: true,
      loginFailedRoute: '/login',
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
      scopes: ['user.read', 'openid'],
    }
  },
  s3: {
    bucketName: 'ifm2-dev',
    folderPath: 'iot-certificates/',
    chatBucket: 'ifm-chat-files'
  },
};
